module.exports = __webpack_public_path__ + "static/media/detectDataImage8_en.b1832a15.png";